import { Directive, HostBinding } from '@angular/core';

@Directive({
    standalone: true,
    selector: '[appMatStrokedButtonBorder]',
})
export class MatStrokedButtonBorderDirective {
    @HostBinding('class') elementClass = 'appMatStrokedButtonBorder';
}
